import {useState} from 'react'
import {PageLink, PageTitle} from '../../_metronic/layout/core'
import {TCieloMerchantRequest} from '../../coreGlobal/models/admin/cieloMerchant'
import {useFormik} from 'formik'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import {createCieloMerchant} from './core/_request'
import {cieloMerchantSchema} from './core/validation/CieloMerchantsVali'
import {CieloMerchantForm} from './components/CieloMerchantForm'
import {BuildRequest} from './core/BuildRequest'

const CieloMerchantBreadcrumbs: Array<PageLink> = [
  {
    title: 'Admin',
    path: '/admin/cielo-merchants',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const Create = () => {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const [cieloMerchantInitialValues] = useState<TCieloMerchantRequest>({
    name: '',
    merchant_id: '',
    merchant_key: '',
    ec: '',
    start_date: '',
    expiration_at: '',
    active: true,
    franchise_id: null,
    billing_entity_id: null,
    payment_option_id: null,
  })

  const formik = useFormik({
    initialValues: cieloMerchantInitialValues,
    validationSchema: cieloMerchantSchema,
    onSubmit: async (values) => {
      const valuesFilter = await BuildRequest(values)
      submit(valuesFilter)
    },
  })

  const submit = async (req: TCieloMerchantRequest) => {
    await Swal.fire({
      title: 'Deseja adicionar o Cielo Merchant?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true)
        try {
          await createCieloMerchant(req)
          await Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Cielo Merchant adicionado com sucesso',
            showConfirmButton: false,
            timer: 1500,
          })

          navigate('/admin/cielo-merchants', {replace: true})
        } catch (error: any) {
          if (error.response.status === 422) {
            let errorText = ''
            for (let key in error.response.data.errors) {
              errorText += '<li>' + error.response.data.errors[key][0] + '</li>'
            }
            await Swal.fire({
              icon: 'error',
              title: 'Ops! Revise seu formulário e tente novamente!',
              html: errorText,
            })
          } else {
            await Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: error.response.data.message,
              timer: 2000,
            })
          }
        } finally {
          setLoading(false)
        }
      }
    })
  }
  return (
    <>
      <CieloMerchantForm formik={formik} />
    </>
  )
}
export const CieloMerchantCreatePage = () => {
  return (
    <>
      <PageTitle breadcrumbs={CieloMerchantBreadcrumbs}>Adicionar Cielo Merchant</PageTitle>
      <Create />
    </>
  )
}
